<script>
import DatatableCustom from "@/components/widgets/datatable-custom.vue";
import Aulive from "./aulive";

export default {
  components: {
    DatatableCustom,
    Aulive,
  },
  data() {
    return {
      aluno: { codusuario: null },
      aulive: {
        descricao: null,
        data: null,
        hora_ini: null,
        hora_fim: null,
        link_lt: null,
      },
      aulives: [],
      fields: [
        { key: "descricao", label: "Descrição", sortable: true },
        { key: "data", label: "Dia", sortable: true },
        { key: "hora_ini", label: "Início", sortable: true },
        { key: "hora_fim", label: "Fim", sortable: true },
      ],
      filterOn: [],
      jaBuscou: false,
      buscando: false,
    };
  },
  methods: {
    get(codusuario) {
      this.$emit("carregando", true);
      this.aulives = [];
      this.buscando = true;
      this.jaBuscou = true;
      const params = {
        username: codusuario,
      };
      const url = process.env.VUE_APP_API_URL + "/api/aluno/proximas_aulives";
      const headers = this.$headers;
      this.$axios
        .get(url, { headers, params })
        .then((response) => (this.aulives = response.data))
        .catch((error) => this.$axiosCatch(error))
        .finally(() => {
          this.buscando = false;
          this.$emit("carregando", false);
        });
    },
    linhaSelecionada(linha) {
      this.aulive = linha;
      this.$refs.aulive.handler();
    },
  },
};
</script>
<template>
  <div class="row">
    <template v-if="buscando">
      <div class="col">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Buscando...
      </div>
    </template>
    <template v-else>
      <DatatableCustom
        v-on:linhaSelecionada="linhaSelecionada"
        :filterOn="filterOn"
        :items="aulives"
        :fields="fields"
        :jaBuscou="jaBuscou"
      ></DatatableCustom>
      <Aulive ref="aulive" :aulive="aulive"
    /></template>
  </div>
</template>
